export const N77 = {
  "columns": 6,
  "rows": 1,
  "visual": {
    "id": 1,
    "type": "combo",
    "colorTheme": "colorTheme1",
    "title": "Quarterly % Performance (Sales vs Target)",
    "orientation": "vertical",
    "xAxis": "",
    "yAxis": "",
    "binding": {
      "data": {
        "series": [
          {
            "name": "ActualSales",
            "value": "ActualSales",
            "type": "column"
          },
          {
            "name": "TargetSales",
            "value": "TargetSales",
            "type": "column"
          },
          {
            "name": "Performance %",
            "value": "Perf",  
            "type": "line",
            "yAxisIndex": 1   
          }
        ],
        "title": "Quarter",
        "endpoint": "N77", 
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
           { "key": "FromYear", "value": "1" },
           { "key": "ToMonth", "value": "2024" },
           { "key": "ToYear", "value": "1" },
           { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {}
        }
      }
    }
  }
}
